import { IProfile, IServerProfile, IServerUserInfo, IUserInfo, IUserInfoPayload } from 'shared/models/Profile'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { ProfileConverter } from './ProfileConverter'
import { IDefaultChangePassword, ITransactionFilters } from './types/types'

class ProfileApi extends BaseHttpService {
  private converter

  private usersUrl

  private transactionsUrl

  private newPaymentsUrl

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/user`
    this.usersUrl = `${baseUrl}/api/users`
    this.transactionsUrl = `${baseUrl}/api/backoffice/transactions`
    this.converter = new ProfileConverter()
    this.newPaymentsUrl = `${baseUrl}/api/backoffice/payments/v2`
  }

  async loadTransfersList(filters: ITransactionFilters) {
    return this.sendQuery({
      url: `${this.transactionsUrl}/`,
      type: QueryTypes.GET,
      data: filters,
      converterSuccess: this.converter.convertTransfersList,
    })
  }

  async withdrawCashier(withdraw: number, currencies: string, parent: number) {
    return this.sendQuery({
      url: `${this.transactionsUrl}/`,
      type: QueryTypes.POST,
      data: { amount: withdraw, currency: currencies, recipient_id: parent },
    })
  }

  async getProfileInfo() {
    return this.sendQuery<IServerProfile, IProfile>({
      url: `${this.baseUrl}/profile`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertProfileInfo,
    })
  }

  async getUserInfo() {
    return this.sendQuery<IServerUserInfo, IUserInfo>({
      url: `${this.usersUrl}/user/info/`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertUserInfo,
    })
  }

  async updateUserInfo(data: IServerUserInfo) {
    return this.sendQuery<IServerUserInfo, boolean>({
      url: `${this.usersUrl}/user/info/`,
      type: QueryTypes.PATCH,
      data,
    })
  }

  async changePassword(data: IDefaultChangePassword) {
    return this.sendQuery<IServerProfile, IProfile>({
      url: `${this.usersUrl}/user/change-password/`,
      type: QueryTypes.POST,
      data,
    })
  }

  async sendKYCpicture(data: FormData) {
    return this.sendQuery({
      url: `${this.usersUrl}/documents/upload/`,
      type: QueryTypes.POST,
      data,
    })
  }
}

export default ProfileApi
